export class ListaTarefa {
  itens: ItemTarefa[] = [];
}
export class ItemTarefa {
  id: number;
  descricao: string;
  dataCadastro: Date;
  dataPrevisaoFinalizacao: Date;
  dataInicial: Date;
  dataFinalizacao: Date;
  responsavel: string;
  tipoTarefa: string;
  atendimentoId: number | null;
  atendimento: string | null;
  cliente: string;
  nova: boolean = false;
  status: number;
  atrasada: boolean;
  finalizada: boolean;
}
